import React, {PureComponent} from "react"
import {FormattedMessage} from "@irati/utils/lang"
import {ButtonRouterLink} from "@irati/ui/src/Link"
import H2 from "./styled/H2"
import Paragraph from "./styled/Paragraph"
import {ADD_TEAM} from "../../../routes/routeConfig"

class NoTeams extends PureComponent {
  render() {
    return (
      <div className="center">
        <H2>
          <FormattedMessage id="admin.components.noTeams.header" />
        </H2>
        <Paragraph>
          <FormattedMessage id="admin.components.noTeams.text" />
        </Paragraph>
        <ButtonRouterLink primary to={ADD_TEAM} id="admin_teams_buttonCreateTeam">
          <FormattedMessage id="admin.components.noTeams.button.text" />
        </ButtonRouterLink>
      </div>
    )
  }
}

export default NoTeams
